import BaseServiceCrud from './BaseServiceCrud';

export default class MobileUserImportService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'bo-user-import-log';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
            userImportId: criteria?.userImportId,
            status: criteria?.status?.enumValue,
            userFullName: criteria.userFullName
        });
    }

    getUserImportList(criteria) {
        const queryString = this.getCriteria(criteria);
        return this.fetch(`${this.domain}/${this.path}/user-imports${queryString}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getImportLogList(criteria, userImportId) {
        const queryString = this.getCriteria(criteria);
        return this.fetch(`${this.domain}/${this.path}/import-logs${queryString}&userImportId=${userImportId}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

   
}
